import IdTokenVerifier from 'idtoken-verifier'

const decodeToken = token => {
  const idTokenVerifier = new IdTokenVerifier()
  return idTokenVerifier.decode(token).payload
}

export default decodeToken
